import type { BreadcrumbItem } from "@octopusdeploy/design-system-components";
import type { EndpointRegistrationKey } from "@octopusdeploy/portal-routes";
import { links } from "@octopusdeploy/portal-routes";
import * as React from "react";
import { repository } from "~/clientInstance";
import endpointRegistry from "../MachineSettings/Endpoints/endpointRegistry";
import { DiscoverWorkerOrDeploymentTargetPage } from "./DiscoverWorkerOrDeploynentTargetPage";
interface WorkerMachineDiscoveryPageProps {
    spaceId: string;
    workerPoolId?: string;
    endpointKey: EndpointRegistrationKey;
}
export function DiscoverWorkerPage({ spaceId, workerPoolId, endpointKey }: WorkerMachineDiscoveryPageProps) {
    const registration = endpointRegistry.getMachine(endpointKey);
    const title = `Create ${registration ? registration.name : "worker"}`;
    const breadcrumbItems: BreadcrumbItem[] = [
        {
            label: "New Worker",
            pageUrl: links.selectWorkerTypePage.generateUrl({ spaceId }, { workerPoolId }),
        },
    ];
    const discover = (host: string, port: number, type: {}, proxyId: string | undefined) => repository.Workers.discover(host, port, type, proxyId);
    return (<DiscoverWorkerOrDeploymentTargetPage title={title} machineTypeDescription={"worker"} createLink={links.addWorkerPage} discover={discover} breadcrumbItems={breadcrumbItems} endpointKey={endpointKey} workerPoolId={workerPoolId} spaceId={spaceId}/>);
}
